import { IAction, IActionMethods, StateStatus } from '../../utils/common';
import * as Types from './types';
import * as AuthenticationService from '../../../services/api/authenticate';
import { Dispatch } from 'redux';
// import { showToastAction } from '../../../components/atoms/toast_message';
// import { LanguagesEnum } from '../../../config/languages';
import NavigationConfig from '../../../navigation/config';

/** Forgot Password  */

interface IForgotPasswordInput {
  username: string;
  history: any;
}
class ForgotPassword implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.FORGOT_PASSOWRD,
      data: {
        status: StateStatus.Pending,
      },
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.FORGOT_PASSOWRD,
      data: {
        status: StateStatus.Success,
      },
    };
  }

  onFailed(): IAction {
    return {
      type: Types.FORGOT_PASSOWRD,
      data: {
        status: StateStatus.Failed,
      },
    };
  }

  action(data: IForgotPasswordInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await AuthenticationService.forgotPassword({
          username: data.username,
        });
        dispatch(this.onSuccess());
        // showToastAction(
        //   dispatch,
        //   {
        //     [LanguagesEnum.English]:
        //       'Email has been sent to your email to reset your password',
        //     [LanguagesEnum.Greek]:
        //       'Στάλθηκε email για την επαναφορά του κωδικού',
        //   },
        //   'success'
        // );
        data.history.push(NavigationConfig.loginPage().path);
      } catch (error: any) {
        // console.log('ForgotPassword Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
        // showToastAction(
        //   dispatch,
        //   {
        //     [LanguagesEnum.English]: 'Something goes wrong',
        //     [LanguagesEnum.Greek]: 'Κάτι πήγε στραβά',
        //   },
        //   'error'
        // );
      }
    };
  }
}

interface IResetPasswordInput {
  password: string;
  confirmPassword: string;
  token: string;
  history: any;
}

class ResetPassword implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.RESET_PASSWORD,
      data: {
        status: StateStatus.Pending,
      },
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.RESET_PASSWORD,
      data: {
        status: StateStatus.Success,
      },
    };
  }

  onFailed(): IAction {
    return {
      type: Types.RESET_PASSWORD,
      data: {
        status: StateStatus.Failed,
      },
    };
  }

  action(data: IResetPasswordInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let result = await AuthenticationService.resetPassword({
          password: data.password,
          confirm_password: data.confirmPassword,
          token: data.token,
        });
        dispatch(this.onSuccess());
        // showToastAction(
        //   dispatch,
        //   {
        //     [LanguagesEnum.English]: result.message,
        //     [LanguagesEnum.Greek]: result.message,
        //   },
        //   'success'
        // );
        data.history.push(NavigationConfig.loginPage().path);
      } catch (error: any) {
        // console.log('ResetPassword Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
        // showToastAction(
        //   dispatch,
        //   {
        //     [LanguagesEnum.English]: error.message || 'Something goes wrong',
        //     [LanguagesEnum.Greek]: error.message || 'Κάτι πήγε στραβά',
        //   },
        //   'error'
        // );
      }
    };
  }
}

export default {
  forgotPasswordAction: (username: string, history: any) =>
    new ForgotPassword().action({ username, history }),
  resetPasswordAction: (
    password: string,
    confirmPassword: string,
    token: string,
    history: any
  ) =>
    new ResetPassword().action({ password, confirmPassword, token, history }),
};
